export default __webpack_public_path__ + "static/media/loading-icon.f21bde92.svg";